import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @module ol/layer/Vector
 */
import BaseVectorLayer from './BaseVector.js';
import CanvasVectorLayerRenderer from '../renderer/canvas/VectorLayer.js';
/**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */

var VectorLayer =
/*#__PURE__*/
function (_BaseVectorLayer) {
  _inherits(VectorLayer, _BaseVectorLayer);

  /**
   * @param {import("./BaseVector.js").Options<VectorSourceType>} [options] Options.
   */
  function VectorLayer(options) {
    _classCallCheck(this, VectorLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(VectorLayer).call(this, options));
  }

  _createClass(VectorLayer, [{
    key: "createRenderer",
    value: function createRenderer() {
      return new CanvasVectorLayerRenderer(this);
    }
  }]);

  return VectorLayer;
}(BaseVectorLayer);

export default VectorLayer;